import { createSlice } from "@reduxjs/toolkit";

const companyManager = createSlice({
  name: "companyManager",
  initialState: {
    dashboards: {},
    detailTeacher: {},
    ticketsTeachers: [],
    levelStudent: [],
    usersManagement: [],
    studentManagement: {},
    studentsManagement: {},
    teacherManagement: [],
    classesWithoutTeacher: [],
    classesWithoutTeacherDemo: [],
  },
  reducers: {
    setDashboards(state, { payload }) {
      state.dashboards = payload;
    },
    setDetailTeacher(state, { payload }) {
      state.detailTeacher = payload;
    },
    setUsersManagement(state, { payload }) {
      state.usersManagement = payload;
    },
    setStudentManagement(state, { payload }) {
      state.studentManagement = payload;
    },
    setStudentsManagement(state, { payload }) {
      state.studentsManagement = payload;
    },
    setTicketsTeachers(state, { payload }) {
      state.ticketsTeachers = payload;
    },
    setLevelStudent(state, { payload }) {
      state.levelStudent = payload;
    },
    setTeacherManagement(state, { payload }) {
      state.teacherManagement = payload;
    },
    setClassesWithoutTeacher(state, { payload }) {
      state.classesWithoutTeacher = payload;
    },
    setClassesWithoutTeacherDemo(state, { payload }) {
      state.classesWithoutTeacherDemo = payload;
    },
  },
});

export const {
  setDashboards,
  setDetailTeacher,
  setUsersManagement,
  setTicketsTeachers,
  setStudentManagement,
  setStudentsManagement,
  setLevelStudent,
  setTeacherManagement,
  setClassesWithoutTeacher,
  setClassesWithoutTeacherDemo,
} = companyManager.actions;

export default companyManager.reducer;
